import { render, staticRenderFns } from "./EmployeeAdmittanceCard.vue?vue&type=template&id=47539b65&scoped=true&"
import script from "./EmployeeAdmittanceCard.vue?vue&type=script&lang=js&"
export * from "./EmployeeAdmittanceCard.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAdmittanceCard.vue?vue&type=style&index=0&id=47539b65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47539b65",
  null
  
)

export default component.exports
import {QItem,QInput,QToolbar,QSpace,QBtn} from 'quasar'
component.options.components = Object.assign({QItem,QInput,QToolbar,QSpace,QBtn}, component.options.components || {})
